<div class="ms-large-b" *ngIf="isAdminOrTravelBooker$ | async">
  <fcom-button
    data-testid="corporate-navigate-back"
    [icon]="{
      name: SvgLibraryIcon.ARROW_LEFT,
      position: IconPosition.LEFT,
    }"
    [text]="'CORPORATE.corporatePortal.backToMain' | finLocalization"
    [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
    (clickBtn)="navigateBack()"
  ></fcom-button>
</div>

<ng-container *ngIf="user$ | async as user; else loader">
  <h2 class="ms-large-b" *ngIf="isAdminOrTravelBooker$ | async">{{ user.firstname }} {{ user.lastname }}</h2>
  <div
    *ngIf="(isAdminOrTravelBooker$ | async) === false"
    class="font-body-1 mr-large-y"
    data-testid="corporate-personal-details-collecting"
  >
    {{ 'CORPORATE.corporatePortal.personalDataCollectingShort' | finLocalization }}
    <button class="underline bold-type" (click)="aboutModalOpen = true">
      {{ 'CORPORATE.corporatePortal.readMore' | finLocalization }}
    </button>
  </div>

  <div class="flex ms-medium-b">
    <div class="flex flex-1 flex--middle">
      <h4>{{ 'CORPORATE.corporatePortal.personalDetails' | finLocalization }}</h4>
    </div>
    <div class="dn-mobile">
      <fcom-button
        data-testid="corporate-personal-details-button"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [icon]="{
          name: SvgLibraryIcon.EDIT,
          position: IconPosition.LEFT,
        }"
        [text]="'CORPORATE.corporatePortal.editDetails' | finLocalization"
        [disabled]="updating"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        (clickBtn)="editPersonalDetails()"
      ></fcom-button>
    </div>
    <div class="dn-tablet-up">
      <fcom-icon-button
        [icon]="{ name: SvgLibraryIcon.EDIT }"
        [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [size]="IconButtonSize.MEDIUM"
        [disabled]="updating"
        [aria]="{ label: 'CORPORATE.corporatePortal.editDetails' | finLocalization }"
        (clickBtn)="editPersonalDetails()"
      >
      </fcom-icon-button>
    </div>
  </div>
  <div class="ms-xlarge-b">
    <fcom-table
      class="font-body-2"
      [rowData]="personalDetailsData$ | async"
      [cellTemplate]="itemTemplate"
      [mobileTemplate]="mobileTemplate"
      [headers]="headers"
      [usePagination]="false"
      [loading]="updating && editFormType === UserFormType.PERSONAL_DETAILS"
      [caption]="'CORPORATE.corporatePortal.personalDetails' | finLocalization"
    ></fcom-table>
  </div>

  <ng-container *ngIf="false">
    <!-- To be enabled after booking flow supports corporate passport details -->
    <div class="flex ms-medium-b">
      <div class="flex flex-1 flex--middle">
        <h4>{{ 'CORPORATE.corporatePortal.passportDetails' | finLocalization }}</h4>
      </div>
      <div class="dn-mobile">
        <fcom-button
          data-testid="corporate-passport-details"
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [icon]="{
            name: SvgLibraryIcon.EDIT,
            position: IconPosition.LEFT,
          }"
          [text]="'CORPORATE.corporatePortal.editDetails' | finLocalization"
          [disabled]="updating"
          [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
          (clickBtn)="editPassportDetails()"
        ></fcom-button>
      </div>
      <div class="dn-tablet-up">
        <fcom-icon-button
          [icon]="{ name: SvgLibraryIcon.EDIT }"
          [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [size]="IconButtonSize.MEDIUM"
          [disabled]="updating"
          [aria]="{ label: 'CORPORATE.corporatePortal.editDetails' | finLocalization }"
          (clickBtn)="editPassportDetails()"
        >
        </fcom-icon-button>
      </div>
    </div>
    <div class="ms-xlarge-b">
      <fcom-table
        class="font-body-2"
        [rowData]="passportDetailsData$ | async"
        [cellTemplate]="itemTemplate"
        [mobileTemplate]="mobileTemplate"
        [headers]="headers"
        [usePagination]="false"
        [loading]="updating && editFormType === UserFormType.PASSPORT_DETAILS"
        [caption]="'CORPORATE.corporatePortal.passportDetails' | finLocalization"
      ></fcom-table>

      <ng-container *ngIf="passportNotification$ | async as notification">
        <fcom-notification class="ms-small-t" [theme]="NotificationTheme.ALERT">
          {{ notification | finLocalization }}
        </fcom-notification>
      </ng-container>
    </div>
  </ng-container>

  <div class="flex ms-medium-b">
    <div class="flex flex-1 flex--middle">
      <h4>{{ 'CORPORATE.corporatePortal.userDetails' | finLocalization }}</h4>
    </div>
    <div class="dn-mobile" *ngIf="isAdminOrTravelBooker$ | async">
      <fcom-button
        data-testid="corporate-user-details"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [icon]="{
          name: SvgLibraryIcon.EDIT,
          position: IconPosition.LEFT,
        }"
        [text]="'CORPORATE.corporatePortal.editDetails' | finLocalization"
        [disabled]="updating"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        (clickBtn)="editUserDetails()"
      ></fcom-button>
    </div>
    <div class="dn-tablet-up" *ngIf="isAdminOrTravelBooker$ | async">
      <fcom-icon-button
        [icon]="{ name: SvgLibraryIcon.EDIT }"
        [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [size]="IconButtonSize.MEDIUM"
        [disabled]="updating"
        [aria]="{ label: 'CORPORATE.corporatePortal.editDetails' | finLocalization }"
        (clickBtn)="editUserDetails()"
      >
      </fcom-icon-button>
    </div>
  </div>
  <div class="ms-xlarge-b">
    <fcom-table
      class="font-body-2"
      [rowData]="userDetailsData$ | async"
      [cellTemplate]="itemTemplate"
      [mobileTemplate]="mobileTemplate"
      [headers]="userDetailsHeaders"
      [usePagination]="false"
      [loading]="updating && editFormType === UserFormType.USER_DETAILS"
      [caption]="'CORPORATE.corporatePortal.userDetails' | finLocalization"
    ></fcom-table>
  </div>

  <ng-container *ngIf="deactivationEnabled$ | async">
    <hr class="nordic-blue-50-border" />
    <div class="flex flex--end ps-large-t">
      <fcom-button
        data-testid="corporate-deactivate-button"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [icon]="{
          name: SvgLibraryIcon.TRASH,
          position: IconPosition.LEFT,
        }"
        [text]="'CORPORATE.corporatePortal.deactivateUser' | finLocalization"
        [disabled]="updating"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        (clickBtn)="deactivateUser()"
      ></fcom-button>
    </div>
  </ng-container>
</ng-container>

<ng-template #itemTemplate let-item>
  <div>
    <span *ngIf="item.label">{{ 'CORPORATE.corporatePortal.userDetailsRows.' + item.label | finLocalization }}</span>
    <ng-container *ngTemplateOutlet="itemRenderer; context: { item }"></ng-container>
  </div>
</ng-template>
<ng-template #mobileTemplate let-item>
  <div>{{ 'CORPORATE.corporatePortal.userDetailsRows.' + item.label.data.label | finLocalization }}</div>
  <div class="flex">
    <div class="bold-type">
      <ng-container *ngTemplateOutlet="itemRenderer; context: { item: item.value.data }"></ng-container>
    </div>
    <div *ngIf="item.link.data.link" class="flex flex-1 flex--end">
      <fcom-link
        [href]="item.link.data.link.url"
        [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
        [size]="LinkSize.SMALL"
        [external]="true"
      >
        {{ item.link.data.link.title }}
      </fcom-link>
    </div>
  </div>
</ng-template>
<ng-template #loader>
  <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
</ng-template>
<ng-template #itemRenderer let-item="item">
  <ng-container *ngIf="item.value" [ngSwitch]="item.type">
    <span *ngSwitchCase="DataType.DATE" data-hj-suppress>{{ item.value | finDateFormat: 'DATE' }}</span>
    <span *ngSwitchDefault data-hj-suppress>{{ item.value }}</span>
  </ng-container>
  <div *ngIf="item.link" class="flex flex--end">
    <fcom-link
      [href]="item.link.url"
      [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
      [size]="LinkSize.SMALL"
      [external]="true"
    >
      {{ item.link.title }}
    </fcom-link>
  </div>
  <span *ngIf="!item.label && !item.value && !item.link && !item.allowEmpty">-</span>
</ng-template>

<fcom-modal
  [title]="'CORPORATE.corporatePortal.deactivateUser' | finLocalization"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [fitToContent]="true"
  [overlayClickable]="false"
  [(open)]="confirmModalOpen"
  (confirm)="confirmDeactivation()"
  (close)="confirmModalOpen = false"
>
  <div class="pr-large-x pr-medium-y">{{ 'CORPORATE.corporatePortal.deactivateUserConfirm' | finLocalization }}</div>
</fcom-modal>

<fcom-modal
  [title]="editModalTitle | finLocalization"
  [(open)]="editModalOpen"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [fitToContent]="true"
  [confirmEnabled]="formGroup?.valid"
  [confirmTranslationKey]="'actions.save'"
  [overlayClickable]="false"
  (confirm)="updateUser()"
>
  <div class="pr-large-x pr-medium-y">
    <ng-container [ngSwitch]="editFormType">
      <fin-personal-details-form
        *ngSwitchCase="UserFormType.PERSONAL_DETAILS"
        [formGroup]="personalDetailsForm"
      ></fin-personal-details-form>
      <fin-passport-details-form
        *ngSwitchCase="UserFormType.PASSPORT_DETAILS"
        [formGroup]="passportDetailsForm"
      ></fin-passport-details-form>
      <div *ngSwitchCase="UserFormType.USER_DETAILS">
        <div class="border rounded-large font-body-2 flex ps-small ms-large-b credentials">
          <div class="label">
            {{ 'CORPORATE.corporatePortal.addUser.fields.username.label' | finLocalization }}
          </div>
          <div class="medium-type">{{ (user$ | async)?.userId }}</div>
        </div>
        <fin-user-details-form [formGroup]="userDetailsForm"></fin-user-details-form>
      </div>
    </ng-container>
  </div>
</fcom-modal>

<fcom-modal
  [title]="'CORPORATE.corporatePortal.aboutPersonalDetails' | finLocalization"
  [(open)]="aboutModalOpen"
  [buttons]="ModalButtons.CLOSE"
  [fitToContent]="true"
>
  <div class="pr-large-x pr-medium-y">
    <cms-unstyled-fragment
      class="block font-body-1 white-bg unstyled-fragment-line-height"
      [contentUrl$]="'CORPORATE.fragments.aboutPersonalDetails.url' | finLocalization | finToObservable"
    >
    </cms-unstyled-fragment>
  </div>
</fcom-modal>
